import Section, { SectionProps } from '@lyra/core/components/Section'
import { SelectedInstrument } from '@lyra/web/constants/instruments'
import useOrderQueryParamsForInstrument from '@lyra/web/hooks/useOrderQueryParamsForInstrument'
import useTicker from '@lyra/web/hooks/useTicker'
import { formatInstrumentWithDirection } from '@lyra/web/utils/instruments'
import { useMemo } from 'react'

import TradeForm from './TradeForm'
import TradeFormOrderTypeTabs from './TradeFormOrderTypeTabs'

const EMPTY_SECTION_HEIGHT = 360

type Props = {
  instrumentName: string
  onSubmitOrder?: () => void
} & SectionProps

export default function TradeFormOrderbookQueryParams({
  instrumentName,
  onSubmitOrder,
  ...sectionProps
}: Props) {
  const [orderParams, setOrderParams] = useOrderQueryParamsForInstrument(instrumentName)

  const ticker = useTicker(instrumentName)

  const instruments: SelectedInstrument[] = useMemo(
    () => [
      {
        instrument_name: instrumentName,
        direction: orderParams.direction,
      },
    ],
    [instrumentName, orderParams.direction]
  )

  if (!ticker) {
    return (
      <Section height={EMPTY_SECTION_HEIGHT}>
        <Section.Spinner flexGrow={1} flexShrink={1} />
      </Section>
    )
  }

  const strategyName = formatInstrumentWithDirection(
    instrumentName,
    orderParams.direction === 'buy',
    {
      showExpiry: true,
    }
  )

  return (
    <Section {...sectionProps}>
      <Section.Subheader title={strategyName} />
      <TradeFormOrderTypeTabs
        instruments={instruments}
        orderParams={orderParams}
        setOrderParams={setOrderParams}
        isRfqDisabled
      />
      <TradeForm
        ticker={ticker}
        orderParams={orderParams}
        setOrderParams={setOrderParams}
        onSubmitOrder={onSubmitOrder}
      />
    </Section>
  )
}
